module.exports = __webpack_public_path__ + "assets/img/1.2494fe25.png";